import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué dispositivos de TMS existen?",
    answer:
      "Existen varios dispositivos de TMS, entre ellos el sistema Magnus (utilizado en SAINT®), NeuroStar, Brainsway y Exomind. Cada uno tiene características distintas. SAINT® se administra con el sistema Magnus.",
  },
  {
    question: "¿SAINT® usa un dispositivo distinto?",
    answer:
      "Sí. SAINT® se administra con el sistema de neuromodulación Magnus, fabricado por Magnus Medical, Inc., que combina orientación por fMRI, estimulación theta burst y un calendario acelerado de cinco días.",
  },
];

export const esTmsDevices = makeEsArticle({
  slug: "tms-devices-compared-saint-neurostar-brainsway-exomind",
  title:
    "Dispositivos de TMS comparados: SAINT®, NeuroStar, Brainsway, Exomind",
  description:
    "Comparación de dispositivos de TMS: sistema Magnus (SAINT®), NeuroStar, Brainsway y Exomind. Cada uno tiene características distintas. SAINT® se administra con el sistema Magnus.",
  h1: "Dispositivos de TMS comparados",
  breadcrumbLabel: "Dispositivos de TMS comparados",
  shortAnswer:
    "Existen varios dispositivos de TMS, entre ellos el sistema Magnus (utilizado en SAINT®), NeuroStar, Brainsway y Exomind. Cada uno tiene características distintas en cuanto a orientación, patrón de estimulación y calendario. SAINT® se administra con el sistema Magnus, que combina orientación por fMRI, estimulación theta burst y un calendario acelerado de cinco días.",
  keyTakeaways: [
    "Existen varios dispositivos de TMS.",
    "SAINT® se administra con el sistema Magnus.",
    "El sistema Magnus combina orientación por fMRI y estimulación theta burst.",
    "NeuroStar, Brainsway y Exomind son otros dispositivos de TMS.",
    "Cada dispositivo tiene características distintas.",
  ],
  sections: [
    {
      heading: "Sistema Magnus (SAINT®)",
      paragraphs: [
        "SAINT® se administra con el sistema de neuromodulación Magnus, fabricado por Magnus Medical, Inc. Combina orientación individualizada por fMRI, estimulación theta burst y un calendario acelerado de 50 sesiones durante cinco días.",
      ],
    },
    {
      heading: "Otros dispositivos de TMS",
      paragraphs: [
        "NeuroStar, Brainsway y Exomind son otros dispositivos de TMS convencional. Cada uno tiene características distintas en cuanto a tipo de bobina, patrón de estimulación y usos autorizados por la FDA.",
      ],
    },
    {
      heading: "Cómo elegir",
      paragraphs: [
        "La elección del dispositivo depende del diagnóstico, el historial de tratamiento y otros factores. Una evaluación psiquiátrica es el primer paso. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
